import React, { createContext, useContext, useState } from 'react';

const AdminProviderContext = createContext();

export const AdminContextProvider = ({ children }) => {

    const [networkErr, setNetworkErr] = useState(false);

    return (
        <AdminProviderContext.Provider value={{ networkErr, setNetworkErr }}>
            {children}
        </AdminProviderContext.Provider>
    );
};

export const useAdminContextProvider = () => {
    return useContext(AdminProviderContext);
};
